export default __webpack_public_path__ + "static/media/03__o_4.2dbaf6b4.jpg";